define('entities/signupNumberPortPhoneNumberEntity',[],function() {
    return function(){
        let self = this;

        self.phoneNumber = null;
        self.country= null;
    };
});

